import { DocumentFormBuilderComponent } from "./document-form-builder.component";
import { OnInit } from "@angular/core";
import { Claim } from "../../model/claim.model";
import { ClaimTypes } from "../../model/claim-type.model";
import { DocumentField } from "../../model/document-field";
import { SmartqDocuments } from "../../model/smartq-documents.model";
import { UtilitiesService } from "../../utilities/utilities.service";

export class TripCancellationFormBuilder extends DocumentFormBuilderComponent implements OnInit {
    constructor(claim: Claim){
        super(claim);
        this.documentFormClaimType = ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN];
    }

    setRequiredDocuments(){
        let requiredDocuments: DocumentField[] = [];
        requiredDocuments.push(new DocumentField('AIRTICKET', 'pageSummaryClaim.claimItem.sectionTripCancel.subSupportingDocs.copyTicket', SmartqDocuments.AIRTICKET, true));
        requiredDocuments.push(new DocumentField('DOCCAN', 'pageSummaryClaim.claimItem.sectionTripCancel.subSupportingDocs.suppCancel', SmartqDocuments.CORRESPONDENCE, true));
        requiredDocuments.push(new DocumentField('RECEIPT', 'pageSummaryClaim.claimItem.sectionTripCancel.subSupportingDocs.receipt', SmartqDocuments.INVOICE, true));
        if(this.claim.getClaimTravel().getTripCancellation().getHasExtTransCost()){
            requiredDocuments.push(new DocumentField('EXTRATRANSCOST', 'pageSummaryClaim.claimItem.sectionTripCancel.subSupportingDocs.receiptTrans', SmartqDocuments.RECEIPTTRANSCOST, true));
        }
        if(this.claim.getClaimTravel().getTripCancellation().getHasExtAccomCost()){
            requiredDocuments.push(new DocumentField('EXTRAACCOMCOST', 'pageSummaryClaim.claimItem.sectionTripCancel.subSupportingDocs.receiptAccom', SmartqDocuments.RECEIPTACCOMCOST, true));
        }
        requiredDocuments.push(new DocumentField('CERTIFICATE', 'pageSummaryClaim.claimItem.sectionTripCancel.subSupportingDocs.certificate', SmartqDocuments.PAYMENTDOCUMENT, true));
        if(UtilitiesService.checkForMinors(this.claim)){
            requiredDocuments.push(new DocumentField('PROOFOFREL', 'pageSummaryClaim.claimItem.miscDoc', SmartqDocuments.LEGALDOCUMENT, true));
        }
        this.requiredDocuments = requiredDocuments;
    }
}